module.exports = __webpack_public_path__ + "img/tongren.7f8e535b.jpg";